<div class="ai-chatbot-suggestions">
  <div class="ai-chatbot-suggestions-title">Suggestions</div>
  <div class="ai-chatbot-suggestions-list">
    <button
      type="button"
      *ngFor="let suggestion of suggestions"
      class="ai-chatbot-suggestions-item"
      (click)="suggestionSelected.emit(suggestion.text)"
    >
      <span class="ai-chatbot-suggestions-item-emoji">{{
        suggestion.emoji
      }}</span>
      <span class="ai-chatbot-suggestions-item-text">{{
        suggestion.text
      }}</span>
    </button>
  </div>
</div>

<div class="ai-chatbot-prompt-box-how-to-write">
  <a
    rv-link
    href="https://help.risevision.com/hc/en-us/articles/47532571934996-Create-a-Presentation-with-AI-in-Rise-Vision"
    target="_blank"
    rel="noopener noreferrer"
    class="ai-chatbot-prompt-box-how-to-write-text"
    >How to use AI effectively
  </a>
</div>
